import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';


const About = ({setActiveAbout, page, deviceMobile}) => {


  const [about, setAbout] = useState('');
  const [refOne, inViewOne] = useInView({ threshold: deviceMobile ? 0.2 : 0.5 , triggerOnce:true});
  const [divRefAbout, inViewTwo] = useInView({ threshold: 0.5});

  useEffect(() => {
    if (page?.[1]?.content?.[0]?.text) {
      setAbout(page[1].content[0].text);
    } else {
      setAbout(`Soy Ingeniero Industrial con pasión por la programación, especializado en desarrollo backend con JavaScript (NestJS y ExpressJS), CI/CD y conocimientos en frontend con ReactJS. Me destaco por crear soluciones innovadoras, mantenerme en constante aprendizaje y aplicar buenas prácticas para construir aplicaciones escalables y de alta calidad. Manejo bases de datos SQL y NoSQL, Docker, GitHub Actions, autenticación con tokens, WebSockets, despliegues en la nube y automatización. Comprometido al 100% con cada proyecto, siempre enfocado en aportar valor y superar nuevos retos.`);
         }
  }, [page]);

  useEffect(() => {
    if (inViewTwo) {

      setActiveAbout(true); // Activa el estado del navbar
    } else {
      setActiveAbout(false); // Desactiva el estado cuando ya no está visible
    }
  }, [inViewTwo, setActiveAbout]);
  

  const content_about = (
    <div ref={refOne} className="col-lg-8 text-center px-4 pt-5" >
    <h2 className="text-white mt-0" >Sobre mí</h2>
    <hr className=" divider-light color_about" />
    <p className="text-white text-justify mb-4" >{about}</p>
    <a className="btn btn-about btn-general" href="#services">Iniciemos!</a>
  </div>
  )


  return (
    
      <section ref={divRefAbout} className="page-section" id="about" 
      > 
            <motion.div
              className={`animate ${inViewOne ? 'show' : ''} row gx-4 gx-lg-5 justify-content-center`}
              initial={{ opacity: 0, x: 100 }}
              animate={inViewOne? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 1 }}
              >
              {content_about}
                
            </motion.div>
          
      </section>

  )
}

export default About